import { useState, useRef, useEffect, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function useChatSession() {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const acceptTerms = useCallback(async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API_URL}/api/chat/start`, { accepted_terms: true });
      setSessionId(response.data.session_id);
      setHasAcceptedTerms(true);
      setMessages([{ role: 'assistant', content: response.data.message }]);
    } catch {
      setError('Error al iniciar el chat. Por favor, inténtelo de nuevo.');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const sendMessage = useCallback(async (e) => {
    e.preventDefault();
    if (!inputMessage.trim() || isLoading || !sessionId) return;

    const userMessage = inputMessage.trim();
    setInputMessage('');
    setError('');
    setMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setIsLoading(true);

    try {
      const response = await axios.post(`${API_URL}/api/chat/message`, {
        session_id: sessionId,
        message: userMessage
      });
      setMessages(prev => [...prev, { role: 'assistant', content: response.data.response }]);
    } catch {
      setError('Error al enviar el mensaje. Por favor, inténtelo de nuevo.');
      setMessages(prev => prev.slice(0, -1));
      setInputMessage(userMessage);
    } finally {
      setIsLoading(false);
    }
  }, [inputMessage, isLoading, sessionId]);

  return {
    hasAcceptedTerms,
    sessionId,
    messages,
    inputMessage,
    setInputMessage,
    isLoading,
    error,
    messagesEndRef,
    acceptTerms,
    sendMessage
  };
}
